// extracted by mini-css-extract-plugin
module.exports = {"imageGrid":"ProductSidebarImages_imageGrid__1adzz","formDescription":"ProductSidebarImages_formDescription__3oeyl"};